






















import { sortBy } from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { Auth } from 'aws-amplify'

import { $db } from '@/services/Db'

import EditableTable from '@/components/EditableTable.vue'
import Downloader from '@/components/Downloader.vue'
import InstallForm from './InstallForm.vue'

@Component({ components: { EditableTable, InstallForm, Downloader } })
export default class InstallsPage extends Vue {

	req = { loading: true, errors: [] }
	installs: any[] = []
	sub: { unsubscribe: () => void } | null = null

	columns = ['id', 'firmware', 'installDate', 'license']

	editing = null
	newSymbol = Symbol('New Install')

	created() {
		this.req.loading = true
		const { data, subscription } = $db.subscribe('installs', 'Install', 'id firmware installDate license', this, 'installs')
		this.sub = subscription
		data.then(items => this.installs = items)
			.catch(err => this.req.errors = Array.isArray(err.errors) ? err.errors.map(e => e.message) : [err.message])
			.finally(() => this.req.loading = false)
	}

	destroyed() {
		if(this.sub) {
			this.sub.unsubscribe()
		}
	}

}
